import styled, { css } from 'styled-components';

export const Header = styled.header`
  ${({ theme }) => css`
    align-items: center;
    background: linear-gradient(
      90deg,
      rgba(210, 228, 255, 1) 0%,
      rgba(234, 241, 255, 1) 33.33%,
      rgba(255, 248, 246, 1) 66.66%,
      rgba(255, 237, 231, 1) 100%
    );
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 12px 24px 26px 24px;
    width: 100%;
    border-radius: 8px;
    margin-bottom: -40px;

    @media (max-width: ${theme.breakpoints.md}) {
      padding: 16px;
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
      margin-bottom: -40px;
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      padding: 12px;
      gap: 12px;
    }
  `}
`;

export const HeaderBrand = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 24px;

    @media (max-width: ${theme.breakpoints.sm}) {
      gap: 12px;
    }
  `}
`;

export const HeaderLogo = styled.img`
  ${({ theme }) => css`
    height: auto;
    max-width: 117px;
    width: 100%;

    @media (max-width: ${theme.breakpoints.sm}) {
      max-width: 80px;
    }
  `}
`;

export const HeaderTitleWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-top: -30px;

    @media (max-width: ${theme.breakpoints.sm}) {
      margin-top: -20px;
    }
  `}
`;

export const HeaderMainTitle = styled.h1`
  ${({ theme }) => css`
    background: linear-gradient(90deg, rgba(48, 148, 239, 1) 0%, rgba(215, 5, 192, 1) 30%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 0px;
    display: flex;
    align-items: center;
    gap: 8px;

    @media (max-width: ${theme.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const HeaderSubtitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};

    @media (max-width: ${theme.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const InputsWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 24px;
    background-color: rgba(255, 255, 255, 0.4);
    padding: 12px;
    border-radius: 8px;

    @media (max-width: ${theme.breakpoints.md}) {
      flex-direction: column;
      width: 100%;
      gap: 12px;
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      padding: 8px;
      gap: 8px;
    }
  `}
`;

export const DateInputsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    gap: 8px;
    height: 56px;
    align-items: center;

    @media (max-width: ${theme.breakpoints.sm}) {
      flex-direction: column;
      height: auto;
      width: 100%;
      gap: 8px;
    }
  `}
`;

export const DateInputsSeparator = styled.div`
  ${({ theme }) => css`
    border: 1px solid ${theme.v2.colors.neutral.lowLight};
    width: 8px;

    @media (max-width: ${theme.breakpoints.sm}) {
      display: none;
    }
  `}
`;

export const AccountDropdownWrapper = styled.div`
  ${({ theme }) => css`
    position: relative;

    @media (max-width: ${theme.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const AccountDropdownButton = styled.button`
  ${({ theme, $isOpen }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    border: 1px solid ${$isOpen ? theme.v2.colors.brand.primaryMedium : theme.v2.colors.neutral.highMedium};
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 12px;
    padding: 12px 16px;
    transition: border-color 0.4s ease;
    width: 100%;
    min-width: 225px;
    height: 56px;

    &:hover {
      border: 2px solid ${theme.v2.colors.brand.primaryMedium};
    }

    @media (max-width: ${theme.breakpoints.md}) {
      min-width: auto;
      width: 100%;
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      padding: 10px 12px;
      gap: 8px;
      height: auto;
      min-height: 48px;
    }
  `}
`;

export const AccountIconWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
`;

export const AccountInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  text-align: left;
`;

export const AccountLabel = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const AccountName = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const AccountDropdownMenu = styled.div`
  ${({ theme, $isOpen }) => css`
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
    display: ${$isOpen ? 'flex' : 'none'};
    flex-direction: column;
    margin-top: 8px;
    position: absolute;
    right: 0;
    top: 100%;
    width: 100%;
    z-index: 1000;
    min-width: 322px;

    @media (max-width: ${theme.breakpoints.sm}) {
      min-width: auto;
      left: 0;
      right: 0;
    }
  `}
`;

export const ConnectedAccountsSection = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.white.primary};
    display: flex;
    flex-direction: column;
    padding: 16px;
  `}
`;

export const ConnectedAccountsTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0 0 12px 0;
  `}
`;

export const ConnectedAccountsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
